import { createFileRoute } from '@tanstack/react-router'
import { SsoSelection } from '../../../containers/authentication/components/sso-selection'

export const Route = createFileRoute('/_unauthenticated/ssoSelection/')({
  component: SsoSelection
})
